import Api from '../../../../lib/api';
import * as types from './types';

export const setFetching = (fetching) => {
  return {
    type: types.SET_FETCHING_TRANSACTIONS,
    payload: fetching
  };
};

export const setError = (error) => {
  return {
    type: types.SET_TRANSACTIONS_ERROR,
    payload: error
  };
};

export const setList = (list) => {
  return {
    type: types.SET_TRANSACTIONS_LIST,
    payload: list
  };
};

export const setTotalAmount = (total) => {
  return {
    type: types.SET_TOTAL_AMOUNT_OF_TRANSACTIONS,
    payload: total
  };
};

export const setTransactionTypes = (transactionTypes) => {
  return {
    type: types.SET_TRANSACTION_TYPES,
    payload: transactionTypes
  };
};

export const setEntityTypes = (entityTypes) => {
  return {
    type: types.SET_ENTITY_TYPES,
    payload: entityTypes
  };
};

export const fetchTransactions = (queryParams) => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();
    let {
      errorDefault,
      errorConnection,
    } = localization.strings.hcProfile.projects.actions;

    dispatch(setFetching(true));
    dispatch(setTotalAmount(0));

    let urlQuery = 'transactions';

    let urlParameters = `?${Object.keys(queryParams).map(i => `${i}=${queryParams[i]}`).join('&')}`;

    return Api.getTransactions(`${urlQuery}${urlParameters}`, authToken)
      .then(response => {
        const { rows, totalCount } = response.data;

        if (rows) {
          dispatch(setList(rows));
          dispatch(setTotalAmount(totalCount || 0));
        } else {
          dispatch(setError(errorDefault));
          dispatch(setTotalAmount(0));
        }
      })
      .catch(() => {
        dispatch(setError(errorConnection));
      });
  };
};

export const fetchTransactionTypes = () => {
  return (dispatch, getState) => {
    const { login: { authToken }, localization } = getState();
    let {
      errorDefault,
      errorConnection,
    } = localization.strings.hcProfile.projects.actions;

    return Api.getTransactions('transactions/get-types', authToken)
      .then(response => {
        const { transactionTypes, entityTypes } = response.data;

        if (transactionTypes && entityTypes) {
          dispatch(setTransactionTypes(transactionTypes));
          dispatch(setEntityTypes(entityTypes));
        } else {
          dispatch(setError(errorDefault));
        }
      })
      .catch(() => {
        dispatch(setError(errorConnection));
      });
  };
};

export const setTransactionFilters = (filters, filtersObj) => ({
  type: types.SET_TRANSACTION_FILTERS,
  payload: { filters, filtersObj },
});

export const fetchTransactionsForExport = (queryParams) => {
  return (dispatch, getState) => {
    const { login: { authToken } } = getState();

    let urlQuery = 'transactions';

    let urlParameters = `?${Object.keys(queryParams).map(i => `${i}=${queryParams[i]}`).join('&')}`;

    return Api.getTransactions(`${urlQuery}${urlParameters}`, authToken);
  };
};

export const fetchTransactionsInsuredProjects = (insuredId) => {
  return (dispatch, getState) => {
    const { login: { authToken } } = getState();

    const url = `cf/transactionsInsuredProjects?insuredId=${insuredId}`;

    return Api.get(url, authToken)
      .then(response => {
        const { success, projectInsuredData } = response.data;

        if (success && projectInsuredData) {
          dispatch({
            type: types.SET_INSURED_PROJECTS_MAPPINGS,
            payload: projectInsuredData
          });
        } else {
          dispatch({
            type: types.SET_INSURED_PROJECTS_MAPPINGS_ERROR,
            payload: 'No data found'
          });
        }
      })
      .catch(error => {
        dispatch({
          type: types.SET_INSURED_PROJECTS_MAPPINGS_ERROR,
          payload: 'Failed to load project data'
        });
      });
  };
};

export const logTransaction = (transactionPayload) => {
  return (dispatch, getState) => {
    const { login: { authToken } } = getState();

    return Api.postTransactions('/transactions', transactionPayload, authToken)
      .then(response => {
        return {
          success: true,
          data: response.data
        };
      })
      .catch(error => {
        console.error('Transaction logging post error:', error);
        return {
          success: false,
          error: (error.response && error.response.data) || error.message
        };
      });
  };
};